import { createContext } from 'react'

import { SurveysContextValueType } from './SurveysContext.types'

export const SurveysContext = createContext<SurveysContextValueType | undefined>(undefined)
